import {Component, Input, ViewEncapsulation} from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-side-accordion',
  templateUrl: './side-accordion.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./side-accordion.component.scss'],
})
export class AppSideAccordion{
  @Input() items: any;
  isMobile: boolean = false;
  activeItem: any = {};
  activeListItems:any=[];
  panelOpenState = false;

  setBodyData(item: any) {
    this.activeItem = item;
  }

  constructor(public commonService: CommonService){}
  ngOnInit(): void {
    this.activeItem = this.items[0];

    if(this.commonService.isMobile){
      this.isMobile = true
    }
  }
}
